import React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import globalColors from "../../globalColors";

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export interface snackbarProps {
  open: boolean;
  message: string;
  severity?: "error" | "warning" | "info" | "success";
}
interface CustomSnackbarProps extends snackbarProps {
  onClose: () => void;
}

const CustomSnackbar: React.FC<CustomSnackbarProps> = ({
  open,
  message,
  onClose,
  severity,
}) => {
  return open && message ? (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      autoHideDuration={severity === "success" ? 2000 : 120000}
      onClose={onClose}
      
      sx={{maxWidth:"50%",zIndex:"99999"}}
    >
      <Alert
        onClose={onClose}
        severity={severity ?? "info"}
        sx={
          severity === "success"
            ? {
                width: "100%",
                background: globalColors.colorCombinations.approved.bg,
                color: globalColors.colorCombinations.approved.color,
                whiteSpace: "normal",
              }
            : { width: "100%" }
        }
      >
        {message}
      </Alert>
    </Snackbar>
  ) : (
    <></>
  );
};

export default CustomSnackbar;
